import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import * as Sentry from "@sentry/react";

import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import Button from "@material-ui/core/Button";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Hidden from "@material-ui/core/Hidden";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TablePagination from "@material-ui/core/TablePagination";
import CancelIcon from "@material-ui/icons/Cancel";
import { useHistory } from "react-router-dom";

import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL } from "../../services/configs";
import { IconButton } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";

export default function INRWallet() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const token = useSelector((state) => state.trading.TOKEN);

  const [inrBalance, setInrBalance] = useState(null);
  const [inrTrans, setInrTrans] = useState(null);

  const { bannedTimeout, handleClickAlert } = useContext(CoinContext);

  const statusDisplay = {
    FAILED: "REJECTED",
    IN_PROGRESS: "PENDING",
    AWAITING_ADMIN_ACTION: "PENDING",
    AWAITING_USER_VERIFICATION: "UNVERIFIED",
    APPROVED_BY_ADMIN: "SUCCESS",
    PROCESSED_BY_ADMIN: "SUCCESS",
    REJECTED_BY_ADMIN: "REJECTED",
  };

  const darkStatusColor = {
    SUCCESS: "#C1F4D8",
    FAILED: "#fed9d9",
    IN_PROGRESS: "#fefcd9",
    PENDING: "#fefcd9",
    AWAITING_ADMIN_ACTION: "#fefcd9",
    AWAITING_USER_VERIFICATION: "#fefcd9",
    APPROVED_BY_ADMIN: "#C1F4D8",
    PROCESSED_BY_ADMIN: "#C1F4D8",
    REJECTED_BY_ADMIN: "#fed9d9",
  };

  const darkStatusBackground = {
    SUCCESS: "#20581f",
    FAILED: "#581f1f",
    IN_PROGRESS: "#58571f",
    PENDING: "#58571f",
    AWAITING_ADMIN_ACTION: "#58571f",
    AWAITING_USER_VERIFICATION: "#58571f",
    APPROVED_BY_ADMIN: "#20581f",
    PROCESSED_BY_ADMIN: "#20581f",
    REJECTED_BY_ADMIN: "#581f1f",
  };

  const lightStatusColor = {
    SUCCESS: "#37a609",
    FAILED: "#ff5f5f",
    IN_PROGRESS: "#ffd95f",
    PENDING: "#ffd95f",
    AWAITING_ADMIN_ACTION: "#ffd95f",
    AWAITING_USER_VERIFICATION: "#ffd95f",
    APPROVED_BY_ADMIN: "#37a609",
    PROCESSED_BY_ADMIN: "#37a609",
    REJECTED_BY_ADMIN: "#ff5f5f",
  };

  // for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    getInrBalance();
  }, [token]);

  function getInrBalance() {
    if (token) {
      fetcher(`/v1/balances/INR`)
        .then((data) => {
          // console.log(data);
          if (data[0]) {
            setInrBalance(data[0].availableBalance);
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting INR balance");
    }
  }

  useEffect(() => {
    loadInrTrans();
  }, [page, rowsPerPage]);

  function loadInrTrans() {
    if (token) {
      fetcher(
        `/v1/transfers/inr?sortBy=createdAt&direction=DESC&page=${
          page + 1
        }&pageSize=${rowsPerPage}`
      )
        .then((data) => {
          // console.log(data);
          if (!data.status) {
            setInrTrans(data);
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting INR transactions");
    }
  }

  function cancelRequest(cancelId) {
    if (cancelId) {
      fetcher(`/v1/transfers/inr/cancel/${cancelId}`, { method: "POST" })
        .then((res) => {
          handleClickAlert("success", "Request cancelled successfully.");

          getInrBalance();
          loadInrTrans();
          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", "Failed to cancel request");
          console.error(err);
          // console.error(err);
        });
    } else {
      handleClickAlert("error", "Failed to cancel request");
    }
  }

  return (
    <div className={classes.container}>
      <Typography
        style={{ marginBottom: "20px", fontSize: "40px", fontWeight: "bold" }}
      >
        INR Wallet
      </Typography>

      {/*Visible for md, lg and xl*/}
      <Hidden smDown>
        <Box display="flex" justifyContent="space-between">
          <Box>
            <p style={{ margin: 0, color: "#929399", fontSize: "15px" }}>
              Wallet Balance
            </p>
            <p className={classes.amount}>
              &#x20B9; {inrBalance ? Number(inrBalance) : "0"}
            </p>
          </Box>

          <div>
            {/* <Button
              onClick={() => {
                history.push(`/bank`);
              }}
              color="primary"
              variant="outlined"
              className={classes.withdrawButton}
              style={{ marginRight: "20px" }}
            >
              Banks
            </Button> */}
            <Link to="/wallet/inr/deposit">
              <Button
                // onClick={() => {
                //   if(checkBank() === true){
                //     history.push(`/inr/deposit`);
                //   }
                //   console.log(checkBank())
                // }}
                // onClick={() => {
                //   checkBank("deposit");
                // }}
                color="primary"
                variant="contained"
                className={classes.depositButton}
              >
                Deposit INR to Wallet
              </Button>
            </Link>
            <Link to="/wallet/inr/withdraw">
              <Button
                // onClick={() => {
                //   if(checkBank() === true){
                //     history.push(`/inr/withdraw`);
                //   }
                // }}
                // onClick={() => {
                //   checkBank("withdraw");
                // }}
                color="primary"
                variant="outlined"
                className={classes.withdrawButton}
              >
                Withdraw INR from Wallet
              </Button>
            </Link>
          </div>
        </Box>
      </Hidden>

      {/*Visible for md, xs*/}
      <Hidden mdUp>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <p style={{ margin: 0, color: "#929399", fontSize: "15px" }}>
              Wallet Balance
            </p>
            <p className={classes.amount}>
              &#x20B9; {inrBalance ? inrBalance : "0"}
            </p>
          </Box>

          <div>
            <Link to="/wallet/inr/deposit">
              <Button
                style={{
                  marginTop: "10px",
                  marginLeft: "34px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                // onClick={() => {
                //   checkBank("deposit");
                // }}
                color="primary"
                variant="contained"
                className={classes.depositButton}
              >
                Deposit INR to Wallet
              </Button>
            </Link>
            <Link to="/wallet/inr/withdraw">
              <Button
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                // onClick={() => {
                //   checkBank("withdraw");
                // }}
                color="primary"
                variant="outlined"
                className={classes.withdrawButton}
              >
                Withdraw INR from Wallet
              </Button>
            </Link>
          </div>
        </div>
      </Hidden>

      <div className={classes.table}>
        <TableContainer component="div">
          <Table aria-label="STOCKS TABLE">
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableHeading}
                  align="left"
                  colSpan={6}
                >
                  Transactions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow className={classes.tableHeadText}>
                <TableCell className={classes.tableHeadText} align="center">
                  DATE & TIME
                </TableCell>
                <TableCell className={classes.tableHeadText} align="center">
                  TYPE
                </TableCell>
                <TableCell className={classes.tableHeadText} align="center">
                  AMOUNT
                </TableCell>
                <TableCell className={classes.tableHeadText} align="center">
                  BALANCE
                </TableCell>
                <TableCell className={classes.tableHeadText} align="center">
                  STATUS
                </TableCell>
                <TableCell
                  className={classes.tableHeadText}
                  align="center"
                  style={{ padding: "0px", width: "1px" }}
                ></TableCell>
              </TableRow>
            </TableHead>
            {inrTrans ? (
              <TableBody>
                {inrTrans.content.map((row) => (
                  <TableRow key={row.id} className={classes.bodyRows}>
                    <TableCell align="center">
                      {row.createdAt.slice(8, 10)}.{row.createdAt.slice(5, 7)}.
                      {row.createdAt.slice(0, 4)} {row.createdAt.slice(11, 16)}
                    </TableCell>
                    <TableCell align="center">{row.side}</TableCell>
                    <TableCell align="center">&#x20B9; {row.amount}</TableCell>
                    <TableCell align="center">
                      {Number(row.userPostBalance).toFixed(2)}
                    </TableCell>
                    <TableCell align="center">
                      {/* <div style={{ display: "flex" }}> */}
                      <div
                        style={{
                          wordBreak: "break-all",
                          borderRadius: "20px",
                          padding: "2px",
                          background:
                            theme.palette.type === "dark"
                              ? darkStatusBackground[row.status]
                              : darkStatusColor[row.status],
                          // width: "115px",
                          margin: "auto",
                          fontWeight: "bold",
                          color:
                            theme.palette.type === "dark"
                              ? darkStatusColor[row.status]
                              : lightStatusColor[row.status],
                          width: "130px",
                          fontSize: "12px",
                        }}
                      >
                        {statusDisplay[row.status]
                          ? statusDisplay[row.status]
                          : row.status}
                      </div>
                      {/* </div> */}
                    </TableCell>
                    <TableCell align="center">
                      {row.status === "AWAITING_USER_VERIFICATION" ? (
                        <IconButton
                          onClick={() => {
                            cancelRequest(row.id);
                          }}
                        >
                          <CancelIcon style={{ color: "#f95656" }} />
                        </IconButton>
                      ) : null}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : null}
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={inrTrans ? inrTrans.totalElements : 10}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      // minWidth: "450px",
      maxWidth: "450px",
    },
    width: "95%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  depositButton: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "8px",
      marginRight: "20px",
      fontSize: "16px",
      paddingTop: "8px",
      paddingRight: "32px",
      paddingBottom: "8px",
      paddingLeft: "32px",
    },
    color: "white",
    fontWeight: "bold",
  },
  withdrawButton: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "8px",
      fontSize: "16px",
      paddingTop: "8px",
      paddingRight: "32px",
      paddingBottom: "8px",
      paddingLeft: "32px",
    },
    fontWeight: "bold",
  },
  amount: {
    margin: 0,
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "26px",
    },
  },
  table: {
    marginTop: "30px",
    background: theme.palette.type === "dark" ? "#151828" : "white",

    position: "relative",
    [theme.breakpoints.down("md")]: {
      "&:after": {
        content: "''",
        position: "absolute",
        zIndex: 1,
        top: "0",
        right: "0",
        bottom: "15px",
        pointerEvents: "none",
        backgroundImage:
          theme.palette.type === "dark"
            ? "linear-gradient(to right,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1))"
            : "linear-gradient(to right, rgba(255, 255, 255, 0), #999 85%)",
        width: "15%",
      },
    },
  },
  tableHeading: {
    fontSize: "20px",
    fontWeight: "bold",
  },
  tableHeadText: {
    fontWeight: "bold",
  },
}));
